import { serviceModesConstants } from '../../_constants';
import { serviceModesService } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const serviceModesActions = {
    getServiceModes,
    getServiceModeById,
    createServiceMode,
    updateServiceMode,
    deleteServiceModes,
    activation,
    getActiveServiceModes,
};

function serviceModesFetching() { return { type: serviceModesConstants.SERVICE_MODES_FETCHING } }
function serviceModesFetched() { return { type: serviceModesConstants.SERVICE_MODES_FETCHED } }

function serviceModesSubmitting() { return { type: serviceModesConstants.SERVICE_MODES_SUBMITTING } }
function serviceModesSubmitted() { return { type: serviceModesConstants.SERVICE_MODES_SUBMITTED } }

function getServiceModes(skip, take, filter, search) {
    return dispatch => {
        dispatch(serviceModesFetching());
        dispatch(userActions.allowLeavePage());
        serviceModesService.getServiceModes(skip, take, filter, search)
            .then(
                serviceModes => {
                    if (serviceModes.length > 0) {
                        dispatch(success(serviceModes));
                        dispatch(serviceModesFetched());
                    } else {
                        dispatch(serviceModesFetched());
                        dispatch(alertActions.warning(serviceModes.message))
                    }
                },
                error => {
                    dispatch(serviceModesFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(serviceModes) { return { type: serviceModesConstants.GET_SERVICE_MODES, serviceModes } }
}
function getServiceModeById(id) {
    return dispatch => {
        dispatch(serviceModesFetching());
        dispatch(userActions.allowLeavePage());
        serviceModesService.getServiceModeById(id)
            .then(
                serviceMode => {
                    dispatch(success(serviceMode))
                    dispatch(serviceModesFetched());
                },
                error => {
                    dispatch(serviceModesFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(serviceMode) { return { type: serviceModesConstants.GET_SERVICE_MODE_BY_ID, serviceMode } }
}
function createServiceMode(payload) {
    return dispatch => {
        dispatch(serviceModesSubmitting());
        dispatch(userActions.notallowLeavePage());
        serviceModesService.createServiceMode(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(serviceModesSubmitted());
                    dispatch(alertActions.success('Service mode added successfully'))
                    window.location.href = '/master_data/service_modes';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(serviceModesSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateServiceMode(payload, id) {
    return dispatch => {
        dispatch(serviceModesSubmitting());
        dispatch(userActions.notallowLeavePage());
        serviceModesService.updateServiceMode(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.success('Service mode updated successfully'))
                    window.location.href = '/master_data/service_modes';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(serviceModesSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteServiceModes(id, type, take) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        serviceModesService.deleteServiceModes(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Service modes deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/service_modes';
                            break;
                        default:
                            dispatch(getServiceModes(0, take));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    switch (type) {
                        case "specific":
                            dispatch(getServiceModeById(id));
                            break;
                        default:
                            dispatch(getServiceModes(0, take));
                            break;
                    }
                }
            );
    };
}
function activation(id, isActive) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        serviceModesService.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getServiceModeById(id));
                    dispatch(alertActions.success(isActive ? 'Service mode activated successfully' : 'Service mode deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getServiceModeById(id));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function getActiveServiceModes() {
    return dispatch => {
        serviceModesService.getActiveServiceModes()
            .then(
                activeServiceModes => {
                    dispatch(success(activeServiceModes))
                },
                error => dispatch(alertActions.error(error.toString()))
            );
    };
    function success(activeServiceModes) { return { type: serviceModesConstants.GET_ACTIVE_SERVICE_MODES, activeServiceModes } }
}